import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";

import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

import toast from "react-hot-toast";

import api from "services/api";
import moment from "moment";
import { capitalCase } from "capital-case";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt from "components/UpStyled/Prompt";

import { compare } from "utils/helper";
import { Spin, Empty } from "antd";
import colors from "assets/theme/base/colors";
import { getStyleImages } from "utils/imageHelper";
import { Paper } from "@mui/material";
import { AccountContext } from "context/account";
import { moodboardSortOptions } from "utils/data";

import SearchIcon from "@mui/icons-material/Search";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import TableRowsIcon from "@mui/icons-material/TableRows";
import GridViewIcon from "@mui/icons-material/GridView";

const FileListView = ({ data }) => {
  const [files, setFiles] = useState([]);

  const [filteredFiles, setFilteredFiles] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(data?.initialStatus || "draft");
  const [sortObj, setSortObj] = useState(moodboardSortOptions[0]);
  const [searchStr, setSearchStr] = useState();
  const [view, setView] = useState("list"); //grid,list

  const account = useContext(AccountContext);

  const navigate = useNavigate();

  useEffect(() => {
    setFiles(data?.data || []);
    setFilteredFiles(data?.data || []);
    setSelectedStatus(data?.initialStatus || "draft");
  }, [data.title, data?.data]);

  const metaFilesKey = ["imageFiles", "techPacksFiles", "referenceFiles"];

  const renderCard = () => {
    if (data?.status && data?.status.length > 0) {
      let dataList = filteredFiles.filter((item) => item.status == selectedStatus);

      return (
        <SuiBox sx={{ borderRadius: 1, height: "100%", overflow: "auto" }} key={data.title}>
          <SuiBox sx={{ mb: 1, py: 1 }}>
            <SuiBox display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
              {data?.status.map((status, index) => {
                return (
                  <>
                    {" "}
                    <SuiButton
                      sx={{ textTransform: "capitalize", p: "4px 12px", mx: 1, minHeight: 24 }}
                      color="dark"
                      variant={selectedStatus == status?.value ? "contained" : "text"}
                      fontWeight="bold"
                      onClick={() => setSelectedStatus(status?.value)}
                    >
                      {status?.label}
                    </SuiButton>
                    {index == data.status.length - 1 ? null : "|"}
                  </>
                );
              })}
            </SuiBox>
          </SuiBox>

          <SuiBox>{renderFileList(dataList)}</SuiBox>
        </SuiBox>
      );
    } else {
      if (filteredFiles.length == 0) {
        return <Empty style={{ margin: "auto" }} />;
      }

      return (
        <SuiBox sx={{ borderRadius: 1, height: "100%", overflow: "auto" }}>
          <SuiBox>{renderFileList(filteredFiles)}</SuiBox>
        </SuiBox>
      );
    }
  };

  const handleSearchChange = (str) => {
    setSearchStr(str);
    handleSearchFiles(str);
  };

  const handleSearchFiles = (search = searchStr, sort = sortObj) => {
    if (search) {
      const strUpper = search.toUpperCase();
      const searchFields = ["name", "title"];
      const searchResults = files.filter((x) => {
        let result = false;
        for (let i = 0; i < searchFields.length; i++) {
          if (x[searchFields[i]]) {
            if (typeof x[searchFields[i]] == "string") {
              if (x[searchFields[i]].toUpperCase().includes(strUpper)) {
                result = true;
              }
            } else if (typeof x[searchFields[i]] == "object") {
              const text = JSON.stringify(x[searchFields[i]]);
              if (text.toUpperCase().includes(strUpper)) {
                result = true;
              }
            }
          }
        }
        return result;
      });

      let sortedList = searchResults.sort((a, b) => compare(a, b, sort.value));

      setFilteredFiles(sortedList);
    } else {
      let sortedList = files.sort((a, b) => compare(a, b, sort.value));

      setFilteredFiles(sortedList);
    }
  };

  const handleOnSortChange = (opt) => {
    setSortObj(opt);
    handleSearchFiles(searchStr, opt);
  };

  const handleViewChange = (e, value) => {
    if (value !== null) {
      setView(value);
    }
  };

  const renderFileList = (myFileList) => {
    if (myFileList.length == 0) {
      return <Empty style={{ margin: "auto" }} />;
    }

    return (
      <SuiBox display="flex" flexWrap="wrap" gap={1}>
        {myFileList.map((item) => {
          let primaryImage = null;
          let title = item.title || item.name;
          let created_at = item.created_at;
          let link = "";

          if (data?.type == "post") {
            primaryImage = item?.metadata?.coverImage;
            link = `/edit-post/${item.id}`;
          } else if (data?.type == "moodboard") {
            primaryImage = item?.img;
            link = `/workspace/moodboard?id=${item.id}`;
          } else if (data?.type == "style") {
            let styleImages = getStyleImages(item, false, metaFilesKey);
            if (styleImages.length > 0) {
              primaryImage = styleImages[0];
            }
            link = `/workspace/styles-master?id=${item.id}&stage=tech-pack`;
          } else if (data?.type == "ailab") {
            primaryImage = item?.img;
            link = `/workspace/fashion-lab/${item.id}`;
          } else if (data?.type == "project") {
            const products = item.products || [];
            let styleImages = [];
            //add style first image
            for (let i = 0; i < products.length; i++) {
              let temp = getStyleImages(products[i], false);
              styleImages.push(...temp);
            }
            //add all project reference image
            const fileList = item?.metadata?.othersFiles || [];
            const files = fileList.filter((f) => f?.type && f.type.includes("image"));
            if (files && files.length > 0) {
              styleImages.push(...files);
            }
            if (styleImages.length > 0) {
              primaryImage = styleImages[0];
            }
            link =
              account.account_type == "de"
                ? `/produce/all-projects?id=${item.id}`
                : `/job/requests?id=${item.id}`;
          }

          return (
            <SuiBox width={190} mx={1}>
              <SuiBox
                display="flex"
                aliginItems="center"
                gap={0.5}
                className="hover-card"
                sx={{
                  borderRadius: ({ borders }) => borders.borderRadius.md,
                  cursor: "pointer",
                }}
                onClick={() => (link ? navigate(link) : null)}
              >
                <SuiBox
                  sx={{
                    borderRadius: ({ borders }) => borders.borderRadius.md,
                    overflow: "hidden",
                    mr: 1,
                    height: 50,
                    width: 50,
                    minWidth: 50,
                    backgroundColor: "#efefef",
                  }}
                >
                  <ImageCardWrapper
                    resizeLimit={0}
                    data={primaryImage}
                    height={50}
                    width={50}
                    style={{
                      height: "auto",
                      maxHeight: 50,
                      width: "100%",
                    }}
                    sx={{
                      display: "flex",
                    }}
                    draggable={false}
                  />
                </SuiBox>
                <SuiBox>
                  <SuiTypography
                    variant="body1"
                    color="dark"
                    sx={{
                      lineHeight: 1.2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: "2",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {title}
                  </SuiTypography>
                  <SuiTypography variant="body2" color="text">
                    {moment(created_at).format("MM/DD/yyyy")}
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          );
        })}
      </SuiBox>
    );
  };

  const columns = [
    {
      Header: "Name",
      accessor: "name",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div style={{ maxWidth: 300 }}>{value}</div>;
      },
    },
    {
      Header: "Last Update",
      accessor: "updated_at",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return value ? moment(value).format("MM/DD/YY HH:mm:ss") : "";
      },
    },
    {
      Header: "Date Created",
      accessor: "created_at",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return value ? moment(value).format("MM/DD/YY HH:mm:ss") : "";
      },
    },
  ];

  return (
    <Card sx={{ height: "100%", p: 2 }}>
      <SuiBox display="flex" justifyContent="space-between" sx={{ px: 1, mb: 1 }}>
        <SuiTypography variant="h6">{data?.title}</SuiTypography>
        <SuiBox display="flex" gap={1} sx={{ maxWidth: 380 }}>
          <SuiBox>
            <SuiSelect
              options={moodboardSortOptions}
              onChange={handleOnSortChange}
              defaultValue={sortObj}
              size="small"
            />
          </SuiBox>
          <SuiBox>
            <SuiInput
              placeholder="Search Keywords"
              type="text"
              onChange={(e) => handleSearchChange(e?.target?.value)}
              size="small"
              value={searchStr}
              icon={{
                direction: "right",
                component: (
                  <SearchIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleSearchChange(searchStr)}
                  />
                ),
              }}
            />
          </SuiBox>
          {/* <ToggleButtonGroup value={view} exclusive onChange={handleViewChange} color="info">
            <Tooltip title="List View">
              <ToggleButton value="list">
                <TableRowsIcon fontSize="sm" />
              </ToggleButton>
            </Tooltip>
            <Tooltip title="Card View">
              <ToggleButton value="grid">
                <GridViewIcon fontSize="sm" />
              </ToggleButton>
            </Tooltip>
          </ToggleButtonGroup> */}

          {data.link ? (
            <SuiButton
              variant="gradient"
              size="small"
              color="dark"
              sx={{
                padding: "0px 8px",
                fontSize: 12,
                lineHeight: 0,
                minHeight: 30,
                textTransform: "capitalize",
                borderRadius: "4px",
                mb: 0.5,
              }}
              onClick={() => {
                navigate(data.link);
              }}
            >
              Create
            </SuiButton>
          ) : null}
        </SuiBox>
      </SuiBox>
      {renderCard()}
    </Card>
  );
};
export default FileListView;
